import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      DELIVERY_ON_THE_WAY: "Obs! Du har en levering ",
      THE_LAST_DELIVERY_IS_ON: "Obs! Din siste levering er ",
    },
    se: {
      DELIVERY_ON_THE_WAY: "Obs! Du har en leverans ",
      THE_LAST_DELIVERY_IS_ON: "Obs! Din sista leverans sker ",
    },

    dk: {
      DELIVERY_ON_THE_WAY: "Obs! Du har en levering ",
      THE_LAST_DELIVERY_IS_ON: "Obs! Sidste levering er ",
    },
  } as const
)[language];
